package com.evoapps.evoshift.data.dto.documents

import kotlinx.serialization.Serializable

/**
 * users/{uid}/staff_documents/{docId} (SH-122): the description of a file in Storage at
 * users/{uid}/staff_documents/{workplaceId}/{docId}. firestore.rules (validStaffDocument) allows
 * only these fields; timestamps are ISO-8601 UTC, [expiresOn] "YYYY-MM-DD".
 */
@Serializable
data class StaffDocumentDto(
    val id: String = "",
    val userId: String = "",
    val workplaceId: String = "",
    val type: String = "OTHER",
    val fileName: String = "",
    val contentType: String = "",
    val sizeBytes: Int = 0,
    val expiresOn: String? = null,
    val uploadedAt: String? = null,
    val uploadedBy: String? = null
)

/** workplaces/{wpId}/policies/{policyId}: a PDF at the same path in Storage. */
@Serializable
data class WorkplacePolicyDto(
    val id: String = "",
    val workplaceId: String = "",
    val title: String = "",
    val fileName: String = "",
    val sizeBytes: Int = 0,
    val publishedAt: String? = null,
    val publishedBy: String? = null
)

/** workplaces/{wpId}/policies/{policyId}/acknowledgements/{uid}: written by acknowledgePolicy only. */
@Serializable
data class PolicyAcknowledgementDto(
    val userId: String = "",
    val workplaceId: String = "",
    val policyId: String = "",
    val acknowledgedAt: String = "",
    val displayName: String? = null
)
